export default __webpack_public_path__ + "static/spot-illos-light-31d813f0c5f0dece651d1b53ad29d241.png";